// src/helper/addToQueue/add-queue-item.js
import { fetchAuthSession } from '@aws-amplify/core';

// Load AWS SDK using require (consistent with your original code)
const AWS = require("aws-sdk");

// Define queue URL
const queueURL = "https://sqs.ap-southeast-1.amazonaws.com/533143465269/DreamStreamManifestDeployementQueue";

/**
 * Adds data to the SQS queue
 * @param {string} manifestId - The manifest ID to deploy
 * @param {string} accessToken - The access token for authentication
 * @returns {Promise} - A promise that resolves when message is sent
 */
export const addDataToQueue = async (manifestId, accessToken) => {
  try {
    // Set the region explicitly (using the correct region, not "REGION")
    AWS.config.update({ region: "ap-southeast-1" });
    
    // Get credentials from fetchAuthSession
    const { credentials } = await fetchAuthSession();
    
    if (!credentials) {
      throw new Error("No credentials available. User may not be authenticated.");
    }
    
    // Update AWS config with credentials from Amplify
    AWS.config.credentials = new AWS.Credentials({
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken
    });
    
    // Create SQS client
    const sqs = new AWS.SQS({ apiVersion: "2012-11-05" });
    
    // Prepare message
    const message = {
      manifestId: manifestId,
      accessToken,
    };
    
    // Set SQS parameters
    const params = {
      DelaySeconds: 10,
      MessageBody: JSON.stringify(message),
      QueueUrl: queueURL,
    };
    
    // Return a promise wrapping the SQS sendsMessage call
    return new Promise((resolve, reject) => {
      sqs.sendMessage(params, function (err, data) {
        if (err) {
          console.log("Error", err);
          reject(err);
        } else {
          console.log("Success", data.MessageId);
          resolve(data);
        }
      });
    });
  } catch (error) {
    console.error("Error setting up SQS:", error);
    throw error;
  }
};
